//解释运行代码的。
//var foreachIndex;//如果是执行foreach语句内的代码块，则将遍历集合的当前对象行数写入此变量

var ConditionTypeEnum = { And: 1, OR: 2 };
var ObjectTypeEnum = { Entity: 1, EntitySet: 2 };
var ObjectIoTypeEnum = {
  Input: 1,
  HideVariable: 2,
  Output: 3,
  InputOrOutput: 4
};
var ExpressionTypeEnum = { Variable: 1, Constant: 2, Operator: 3, Func: 4 }; //1 变量 2 常量 3 常用操作符  4 函数
var AccessTypeEnum = {
  VariableWriteIn: 1,
  LocalRules: 2,
  GlobalRules: 3,
  SelfIncrement: 4,
  TableInsert: 6,
  TableUpdate: 7,
  TableRemove: 8,
  TableSearch: 9,
  SetClear: 10,
  SetFill: 11,
  LocalInterface: 12,
  TableJoinSearch: 13,
  GetExcelData: 14,
  GetLocalStorData: 15
};
var DataSourceTypeEnum = { Local: 1, API: 2 };
var JoinType = { InnerJoin: 1, LeftJoin: 2, RightJoin: 3, FullJoin: 4 };
var SysParam = {
  SysParam_CpuId: "SysParam_CpuId",
  SysParam_CpcId: "SysParam_CpcId",
  SysParam_TeacherId: "SysParam_TeacherId"
};
import axios from "../http";
import { uuid } from "vue-uuid";
import moment from "moment";
import { updateDBData } from "@/utils/database/indexed-db";
//执行代码块
var execute = async function(content, options) {
  var objectInfos = options.objectInfos; //对象字典：objectInfos,对象数据字典： objectValues;objectValues：key为对象（实体或实体集合）名称,value为实体值（json）或实体集合值(json数组)
  var objectValues = options.objectValues; //objectValues[objectId][fieldId] 对实体进行存取 objectValues[objectId][index][filedId]  对实体集合进行存取
  var dbSqls = [];
  var dataSourceType = options.dataSourceType;
  var tableData = options.tableData;
  await executeProgramStatementBlock(content);
  if (dbSqls.length > 0) {
    await axios.post(`/api/Utils/DataTable/SaveDataBySql`, dbSqls);
  }
  //////////////////////////////////////////////////////////////////////////////////以下为函数功能区////////////////////////////////////////////////////////////////////////////////////////////////
  //解释执行一个程序语句块。codeJson:代码块的代码集合。
  async function executeProgramStatementBlock(codeJson, foreachIndex) {
    //代码块的每一个项目为三种类型:if语句，for循环，数据存取（实体属性存取，实体集合填充，数据库表的操作等）
    var length = codeJson.length;
    for (var j = 0; j < length; j++) {
      var item = codeJson[j];
      if (item.trueContents) await executeIfStatement(item, foreachIndex);
      else if (item.type) await executeAccessObject(item, foreachIndex);
      else if (item.loop) await executeForLoop(item);
      else if (item.stopLoop != null) return false;
      //break
      else if (item.continueLoop != null) return true; //continue
    }
  }

  //解释执行if语句
  async function executeIfStatement(codeJson, foreachIndex) {
    var result = evaluateBooleanExpression(
      codeJson.condition,
      options,
      "",
      foreachIndex
    );
    var codeBody;
    if (result) codeBody = codeJson.trueContents;
    else codeBody = codeJson.falseContents;
    await executeProgramStatementBlock(codeBody, foreachIndex);
  }
  //解释执行For循环语句
  async function executeForLoop(codeJson) {
    var objectSet = objectValues[codeJson.condition.objectName];
    // await objectSet.forEach(async function (obj, index) {
    //     // foreachIndex = index;//更新for循环当前执行行数
    //     var result = await executeProgramStatementBlock(codeJson.loop, index);
    //     if (result == false) return;
    // })

    for (var j = 0; j < objectSet.length; j++) {
      var result = await executeProgramStatementBlock(codeJson.loop, j);
      if (result == false) break;
    }
  }

  //解释执行变量（实体属性）的数据存取，即对实体属性的操作
  async function executeAccessObject(codeJson, foreachIndex) {
    var type = codeJson.type;
    if (type == AccessTypeEnum.VariableWriteIn) {
      writeVariable(codeJson.content, foreachIndex);
    } else if (type == AccessTypeEnum.SetFill) {
      fillObjectSet(codeJson.content, foreachIndex);
    } else if (type == AccessTypeEnum.SetClear) {
      objectValues[codeJson.objectName] = [];
    } else if (type == AccessTypeEnum.SelfIncrement) {
      incrementSelf(codeJson.content, foreachIndex);
    } else if (type == AccessTypeEnum.TableInsert) {
      insertTable(codeJson.content);
    } else if (type == AccessTypeEnum.TableRemove) {
      await removeTable(codeJson.content, foreachIndex);
    } else if (type == AccessTypeEnum.TableUpdate) {
      await updateTable(codeJson.content, foreachIndex);
    } else if (type == AccessTypeEnum.TableSearch) {
      await searchTable(codeJson.content, foreachIndex);
    } else if (type == AccessTypeEnum.LocalRules) {
      console.log("111")
    } else if (type == AccessTypeEnum.TableJoinSearch) {
      await searchTableJoin(codeJson.content, foreachIndex);
    } else if (type == AccessTypeEnum.GetExcelData) {
      await getExcelData(codeJson.content, foreachIndex);
    } else if (type == AccessTypeEnum.GetLocalStorData) {
      getLocalStorData(codeJson.content, foreachIndex);
    }
  }

  //////////////////////////////////工具方法start////////////////////////////////
  //获取本地数据库的数据
  function getLocalStorData(codeJson, foreachIndex) {
    let value = getEvaluateExpressionResult(
      codeJson.right,
      options,
      foreachIndex
    );
    let data = localStorage.getItem(value) || "";
    if (data && typeof data == "string") {
      let newData = JSON.parse(data);
      setObjectValue(codeJson.left.objectName, newData);
    }
  }
  //获取Excel数据
  async function getExcelData(codeJson, foreachIndex) {
    let path = "";
    let sheet = "";
    let page = "";
    let count = "";
    codeJson.info.forEach(item => {
      let right = getEvaluateExpressionResult(
        item.right,
        options,
        foreachIndex
      );
      switch (item.left) {
        case "path":
          path = right;
          break;
        case "sheet":
          sheet = right;
          break;
        case "page":
          page = right;
          break;
        case "count":
          count = right;
          break;
      }
    });
    let res = await axios.get("/api/Utils/ModelFunc/GetExcelData", {
      params: {
        Path: path,
        SheetName: sheet,
        Page: page,
        Count: count
      }
    });
    setObjectValue(codeJson.entitySet.objectName, res.data);
  }
  //删除表数据
  async function removeTable(codeJson, foreachIndex) {
    //从本地数据库获取
    if (dataSourceType == DataSourceTypeEnum.Local) {
      let newData = [];
      let data = tableData[codeJson.tableName];
      for (var j = 0; j < data.length; j++) {
        let res = evaluateBooleanExpression(
          codeJson.condition,
          options,
          data[j],
          foreachIndex
        );
        if (!res) {
          newData.push(data[j]);
        }
      }
      tableData[codeJson.tableName] = newData;
      await updateDBData(tableData);
    } else if (dataSourceType == DataSourceTypeEnum.API) {
      let str = "delete from " + codeJson.tableName + " ";
      let conditionStr = builtSqlWhere(codeJson.condition);
      if (conditionStr) {
        str += " where " + conditionStr;
      }
      str += ";";
      dbSqls.push(str);
    }
  }
  //更新表数据
  async function updateTable(codeJson, foreachIndex) {
    //从本地数据库获取
    if (dataSourceType == DataSourceTypeEnum.Local) {
      let data = tableData[codeJson.tableName];
      for (var j = 0; j < data.length; j++) {
        let res = evaluateBooleanExpression(
          codeJson.condition,
          options,
          data[j],
          foreachIndex
        );
        if (res) {
          codeJson.fields.forEach((item) => {
            let right = getEvaluateExpressionResult(
              item.right,
              options,
              foreachIndex
            );
            data[j][item.left] = right;
          });
        }
      }
      tableData[codeJson.tableName] = data;
      await updateDBData(tableData);
    } else if (dataSourceType == DataSourceTypeEnum.API) {
      let str = "update " + codeJson.tableName + " set ";
      codeJson.fields.forEach((item, index) => {
        if (index != 0) str += ",";
        str +=
          item.left +
          "='" +
          getEvaluateExpressionResult(item.right, options, foreachIndex) +
          "'";
      });
      let conditionStr = builtSqlWhere(codeJson.condition);
      if (conditionStr) {
        str += " where " + conditionStr;
      }
      str += ";";
      dbSqls.push(str);
    }
  }
  //插入数据操作
  function insertTable(codeJson) {
    let object = objectInfos[codeJson.variable.objectName];
    let objectValue = objectValues[codeJson.variable.objectName];
    if (object.type == ObjectTypeEnum.Entity) {
      dbSqls.push(getInsertSql(codeJson, objectValue));
    } else if (object.type == ObjectTypeEnum.EntitySet) {
      objectValue.forEach(item => {
        dbSqls.push(getInsertSql(codeJson, item));
      });
    }
  }
  //获取插入sql
  function getInsertSql(codeJson, objectValue) {
    let id = uuid.v1();
    let sql = "";
    sql += "insert into " + codeJson.tableName;
    sql += " (Id";
    for (var property in objectValue) {
      //插入时默认主键为“Id”
      if (property.toLowerCase() != "id") {
        sql += "," + property;
      } else {
        if (objectValue[property]) {
          id = objectValue[property];
        } else {
          objectValue[property] = id;
        }
      }
    }

    sql += ",CreateTime,OrderNo"; //Id,CreateTime,OrderNo 为表默认字段
    sql += ") values ('" + id + "'";
    for (var k in objectValue) {
      if (k.toLowerCase() != "id") {
        sql += ",'" + objectValue[k] + "'";
      }
    }
    sql += ",'" + moment().format("YYYY-MM-DD HH:mm:ss") + "','0'";
    sql += "); ";
    return sql;
  }
  //执行查询表
  async function searchTable(codeJson, foreachIndex) {
    //从本地数据库获取
    if (dataSourceType == DataSourceTypeEnum.Local) {
      let data = tableData[codeJson.tableName];
      let newData = [];
      let count = 0;
      let top = 0;
      if (codeJson.top.propertyName != "") {
        top = getObjectPropertyValue(
          codeJson.top.objectName,
          codeJson.top.propertyName,
          options,
          foreachIndex
        );
      }
      var object = objectInfos[codeJson.variable.objectName];
      //若是对象类型则取第一条数据赋值
      if (object.type == ObjectTypeEnum.Entity) {
        top = 1;
      } else if (object.type == ObjectTypeEnum.EntitySet) {
        top = 0;
      }
      for (var j = 0; j < data.length; j++) {
        let res = evaluateBooleanExpression(
          codeJson.condition,
          options,
          data[j],
          foreachIndex
        );
        if (res) {
          count++;
          newData.push(data[j]);
          if (top === count) {
            break;
          }
        }
      }
      setObjectValue(codeJson.variable.objectName, newData);
    } else if (dataSourceType == DataSourceTypeEnum.API) {
      let str = "select ";
      //若设有top，则添加top相关字符
      if (codeJson.top.propertyName) {
        str +=
          " top " +
          getObjectPropertyValue(
            codeJson.top.objectName,
            codeJson.top.propertyName,
            options,
            foreachIndex
          );
      }
      str += " * from " + codeJson.tableName;
      //添加条件字符
      let conditionStr = builtSqlWhere(codeJson.condition);
      if (conditionStr) {
        str += " where " + conditionStr;
      }
      //若设有排序，则添加排序字符
      if (codeJson.order.field) {
        str += "order by " + codeJson.order.field + " " + codeJson.order.type;
      }
      // let searchData = await axios.get("/api/Utils/DataTable/GetTableDataBySql",
      //     {
      //         params: { dataBaseLinkId: "1", sql: str }
      //     });
      let searchData = await axios.post(
        `/api/Utils/DataTable/GetTableDataBySql`,
        { dataBaseLinkId: "1", sql: str }
      );
      setObjectValue(codeJson.variable.objectName, searchData.data);
    }
  }
  //连表查询
  async function searchTableJoin(codeJson, foreachIndex) {
    let str = " select distinct ";
    //若设有top，则添加top相关字符
    if (codeJson.top.propertyName) {
      str +=
        " top " +
        getObjectPropertyValue(
          codeJson.top.objectName,
          codeJson.top.propertyName,
          options,
          foreachIndex
        );
    }
    var object = objectInfos[codeJson.variable.objectName];
    object.properties.forEach((item, index) => {
      if (item.dataSource) {
        if (index != 0) {
          str += ",";
        }
        str += item.dataSource + " as " + item.name;
      }
    });
    str += " from " + codeJson.tableName;
    codeJson.join.forEach(item => {
      switch (Number(item.type)) {
        case JoinType.InnerJoin:
          str += " inner join ";
          break;
        case JoinType.LeftJoin:
          str += " left join ";
          break;
        case JoinType.RightJoin:
          str += " right join ";
          break;
        case JoinType.FullJoin:
          str += " full join ";
          break;
      }
      str += item.tableName + " on ";
      item.joinItem.forEach((v, i) => {
        if (i != 0) {
          str += " and ";
        }
        str +=
          item.tableName +
          "." +
          v.leftField +
          "=" +
          v.right.tableName +
          "." +
          v.right.fieldName;
      });
    });
    //添加条件字符
    let conditionStr = builtSqlWhere(codeJson.condition, true);
    if (conditionStr) {
      str += " where " + conditionStr;
    }
    //若设有排序，则添加排序字符
    if (codeJson.order.field) {
      str += " order by " + codeJson.order.field + " " + codeJson.order.type;
    }
    // let searchData = await axios.get("/api/Utils/DataTable/GetTableDataBySql",
    //     {
    //         params: { dataBaseLinkId: "1", sql: str }
    //     });
    let searchData = await axios.post(
      `/api/Utils/DataTable/GetTableDataBySql`,
      { dataBaseLinkId: "1", sql: str }
    );
    setObjectValue(codeJson.variable.objectName, searchData.data);
  }
  //解释执行实体集合的数据填充
  function fillObjectSet(codeJson, foreachIndex) {
    var objectValue = {};
    codeJson.fill.forEach(function(item) {
      var value = getEvaluateExpressionResult(
        item.right,
        options,
        foreachIndex
      );
      objectValue[item.left.propertyName] = value;
    });
    objectValues[codeJson.entitySet.objectName].push(objectValue);
  }
  //解释执行赋值语句
  function writeVariable(codeJson, foreachIndex) {
    var value = getEvaluateExpressionResult(
      codeJson.right,
      options,
      foreachIndex
    );
    setObjectPropertyValue(
      codeJson.left.objectName,
      codeJson.left.propertyName,
      value,
      foreachIndex
    );
  }
  function incrementSelf(codeJson, foreachIndex) {
    var leftVaule = getObjectPropertyValue(
      codeJson.left.objectName,
      codeJson.left.propertyName,
      options,
      foreachIndex
    );
    if (!leftVaule) leftVaule = 0;
    var stepVaule = parseInt(codeJson.step);
    var value = parseInt(leftVaule) + stepVaule; //加上步值，并存入字典
    setObjectPropertyValue(
      codeJson.left.objectName,
      codeJson.left.propertyName,
      value,
      foreachIndex
    );
  }

  //将值写入指定的对象属性
  function setObjectPropertyValue(
    objectName,
    propertyName,
    value,
    foreachIndex
  ) {
    var object = objectInfos[objectName];
    if (object.type == ObjectTypeEnum.Entity) {
      objectValues[objectName][propertyName] = value;
    } else if (object.type == ObjectTypeEnum.EntitySet) {
      objectValues[objectName][foreachIndex][propertyName] = value;
    }
  }
  //将值写入指定的对象
  function setObjectValue(objectName, data) {
    var object = objectInfos[objectName];
    var objectValue = objectValues[objectName];
    //若是对象类型则取第一条数据赋值
    if (object.type == ObjectTypeEnum.Entity) {
      var first = data[0];
      object.properties.forEach(v => {
        objectValue[v.name] = first ? first[v.name.toLowerCase()] : "";
      });
    } else if (object.type == ObjectTypeEnum.EntitySet) {
      //若时对象集合类型则取全部数据赋值
      for (var j = 0; j < data.length; j++) {
        let obj = {};
        object.properties.forEach(v => {
          obj[v.name] = data[j][v.name];
          if (!obj[v.name]) {
            obj[v.name] = data[j][v.name.toLowerCase()];
          }
        });
        objectValue.push(obj);
      }
      // data.forEach(item => {
      //   let obj = {};
      //   object.properties.forEach(v => {
      //     obj[v.name] = item[v.name.toLowerCase()];
      //   });
      //   objectValue.push(obj);
      // });
    }
  }
  //将条件json格式化成sql形式的字符串
  function builtSqlWhere(codeJson, isJoinSearch) {
    if (!codeJson.contents || codeJson.contents.length == 0) {
      return null;
    }
    let str = "";
    var logicStr = "";
    if (codeJson.type == ConditionTypeEnum.And) {
      logicStr = " and ";
    } else {
      logicStr = " or ";
    }
    str += " ( ";
    let count = 0;
    codeJson.contents.forEach(item => {
      let logic = item.logic;
      //如果含有logic属性，则为简单条件
      if (logic) {
        let rightValue = "";
        let field = "";
        let fullField = "";
        if (isJoinSearch) {
          fullField = item.left.tableName + "." + item.left.fieldName;
          field = item.left.fieldName;
        } else {
          fullField = item.left;
          field = item.left.split(".")[1];
        }
        //获取表达式结果
        if (logic != "In")
          rightValue = getEvaluateExpressionResult(item.right, options);
        else {
          //若是属于类型，则默认表达式只有一个选择变量
          let objectValue = objectValues[item.right[0].content.objectName];
          if (Array.isArray(objectValue) && objectValue.length > 0) {
            rightValue += "(";
            objectValue.forEach((v, j) => {
              if (j != 0) rightValue += ",";
              rightValue += "'" + v[field] + "'";
            });
            rightValue += ")";
          } else { 
            rightValue = "(null)";
          }
        }
        if (!rightValue) {
          return true; //continue
        }
        if (count > 0) {
          str += logicStr;
        }
        //dynamic itemContent = item.content;

        //根据操作符拼接字符串
        switch (logic) {
          case "Equal": //等于
            str += fullField + " = '" + rightValue + "' ";
            break;
          case "NotEqual": //不等于
            str += fullField + " != '" + rightValue + "' ";
            break;
          case "Greater": //大于
            str += fullField + " > " + rightValue + " ";
            break;
          case "GreaterThan": //大于等于
            str += fullField + " >= " + rightValue + " ";
            break;
          case "Less": //小于
            str += fullField + " < " + rightValue + " ";
            break;
          case "LessThan": //小于等于
            str += fullField + " <= " + rightValue + " ";
            break;
          case "Like": //包含
            str += fullField + " like '%" + rightValue + "%' ";
            break;
          case "NotLike": //不包含
            str += fullField + " not like '%" + rightValue + "%' ";
            break;
          case "In": //属于
            str += fullField + " in " + rightValue;
            break;
          default:
            break;
        }
        count++;
      }
      //否则为组合条件，再次执行
      else {
        if (count != 0) {
          str += logicStr;
        }
        count++;
        str += builtSqlWhere(item, isJoinSearch);
      }
    });
    str += " ) ";
    return str;
  }
  //////////////////////////////////工具方法end//////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////函数功能区End///////////////////////////////////////////////////////////////////////////////////////////////////////
};

//构造对象字典。variables:对象（实体或实体集合）数组，data:初始化数据JSON, dataSourceType:数据来源方式，若是本地，data则为表数据，若为api，则为相应的输入格式
function builtObjectDict(variables, data, dataSourceType, settingParam) {
  var objectInfos = {},
    objectValues = {};

  function readVariables(objects, data, settingParam) {
    objects.forEach(function (object) {
    
      objectInfos[object.name] = object;
      if (object.type == ObjectTypeEnum.Entity) {
        var objectValue = {};
        if (
          object.ioType == ObjectIoTypeEnum.Input ||
          object.ioType == ObjectIoTypeEnum.InputOrOutput
        ) {
          //如果为输入对象，才需要初始化数据
          if (dataSourceType == DataSourceTypeEnum.Local) {
            object.properties.forEach(function(property) {
              if (property.dataSource ) {
                //如果配置了数据源
                if (data[property.dataSource]) { 
                  objectValue[property.name] = data[property.dataSource];
                }
                else { 
                  objectValue[property.name] = "";
                }
              } else {
                if (data[object.name][property.name]) { 
                  objectValue[property.name] = data[object.name][property.name];
                }
              }
            });
          } else if (dataSourceType == DataSourceTypeEnum.API) {
            object.properties.forEach(function(property) {
              if (!property.dataSource) {
                objectValue[property.name] = data[object.name]
                  ? data[object.name][property.name]
                    ? data[object.name][property.name]
                    : ""
                  : "";
              } else if (property.dataSource.split("_")[0] == "SysParam") {
                objectValue[property.name] = getSysParamValue(
                  property.dataSource
                );
              }
            });
          }
        }
        objectValues[object.name] = objectValue;
      } else if (object.type == ObjectTypeEnum.EntitySet) {
        objectValues[object.name] = []; //实体集合类型的对象，值不支持从输入端导入
        if (
          data[object.name] &&
          // dataSourceType == DataSourceTypeEnum.API &&
          (object.ioType == ObjectIoTypeEnum.Input ||
            object.ioType == ObjectIoTypeEnum.InputOrOutput)
        ) {
          data[object.name].forEach(item => {
            var objectValue = {};
            object.properties.forEach(function(property) {
              objectValue[property.name] = item[property.name]
                ? item[property.name]
                : "";
            });
            objectValues[object.name].push(objectValue);
          });
        }
      }
      if (object.children && object.children.length > 0) {
        readVariables(object.children, data);
      }
    });
    if (settingParam) {
      settingParam.forEach(item => {
        objectValues[item.objectName][item.name] = item.value;
      });
    }
  }

  readVariables(variables, data, settingParam);
  return { objectInfos, objectValues, dataSourceType };
}
//获取系统默认参数
function getSysParamValue(key) {
  let res = "";
  switch (key) {
    case SysParam.SysParam_CpcId:
      res = localStorage.getItem("cpcId");
      break;
    case SysParam.SysParam_CpuId:
      res = localStorage.getItem("coursePlanUserId");
      break;
    case SysParam.SysParam_TeacherId:
      res = localStorage.getItem("teacherId");
      break;
  }
  return res;
}

//计算组合布尔表达式的值,逻辑运算符左边的值一般从对象字典（options.objectValues）里获取，但有时候是例外，从传入的对象（leftItem）里获取，如：本地数据库表查询searchTable
function evaluateBooleanExpression(condition, options, leftItem, foreachIndex) {
  var result = true;
  //计算单个布尔表达式的值
  var evaluateBooleanExpressionSingle = function(condition, foreachIndex) {
    var leftValue = "";
    if (!leftItem) {
      leftValue = getObjectPropertyValue(
        condition.left.objectName,
        condition.left.propertyName,
        options,
        foreachIndex
      );
    } else {
      leftValue = leftItem[condition.left.split(".")[1].toLowerCase()];
    }

    var rightValue = null;
    if (condition.logic != "In") {
      //若为In类型则默认右边为数组，取整个数组
      rightValue = getEvaluateExpressionResult(
        condition.right,
        options,
        foreachIndex
      );
    } else {
      var objectValues = options.objectValues;
      let arry = objectValues[condition.right[0].content.objectName];
      rightValue = [];
      arry.forEach(item => {
        rightValue.push(item[condition.left.split(".")[1]]);
      });
    }
    return compare(leftValue, rightValue, condition.logic);
  };
  if (condition.type == ConditionTypeEnum.And) {
    for (var j = 0; j < condition.contents.length; j++) {
      let item = condition.contents[j];
      if (item.logic)
        //如果含有logic属性，则为简单条件
        result = evaluateBooleanExpressionSingle(item, foreachIndex);
      //否则为组合条件
      else
        result = evaluateBooleanExpression(
          item,
          options,
          leftItem,
          foreachIndex
        );
      if (!result) break; //break 若为And，有一个为false则返回
    }
  } else if (condition.type == ConditionTypeEnum.OR) {
    for (var i = 0; i < condition.contents.length; i++) {
      let item = condition.contents[i];
      if (item.logic)
        //如果含有logic属性，则为简单条件
        result = evaluateBooleanExpressionSingle(item, foreachIndex);
      //否则为组合条件
      else
        result = evaluateBooleanExpression(
          item,
          options,
          leftItem,
          foreachIndex
        );
      if (result) return result; //break 若为or，有一个为true则返回
    }
  }
  return result;
}

//////////////////////////////////////////////////////////////////////////////////////////////////
function compare(variableValue, paramValue, compareType) {
  var result = false;
  switch (compareType) {
    case "Equal": //等于
      if (variableValue == paramValue) {
        result = true;
      }
      break;
    case "NotEqual": //不等于
      if (variableValue != paramValue) {
        result = true;
      }
      break;
    case "Greater": //大于
      if (parseFloat(variableValue) > parseFloat(paramValue)) {
        result = true;
      }
      break;
    case "GreaterThan": //大于等于
      if (parseFloat(variableValue) >= parseFloat(paramValue)) {
        result = true;
      }
      break;
    case "Less": //小于
      if (parseFloat(variableValue) < parseFloat(paramValue)) {
        result = true;
      }
      break;
    case "LessThan": //小于等于
      if (parseFloat(variableValue) <= parseFloat(paramValue)) {
        result = true;
      }
      break;
    case "Null": //为空
      if (null == variableValue || "" == variableValue) {
        result = true;
      }
      break;
    case "NotNull": //不为空
      if (null != variableValue && "" != variableValue) {
        result = true;
      }
      break;
    case "Like": //包含
      if (variableValue.indexOf(paramValue) != -1) {
        result = true;
      }
      break;
    case "NotLike": //不包含
      if (variableValue.indexOf(paramValue) == -1) {
        result = true;
      }
      break;
    case "In":
      if (paramValue.indexOf(variableValue) > -1) {
        result = true;
      }
      break;
  }
  return result;
}

//获取实体属性值
function getObjectPropertyValue(
  objectName,
  propertyName,
  options,
  foreachIndex
) {
  var objectInfos = options.objectInfos;
  var objectValues = options.objectValues;
  var object = objectInfos[objectName];
  var value = "";
  if (object.type == ObjectTypeEnum.Entity) {
    value = objectValues[objectName][propertyName];
  } else if (object.type == ObjectTypeEnum.EntitySet) {
    value = objectValues[objectName][foreachIndex][propertyName];
  }
  if (!value) {
    let properties = objectInfos[objectName].properties;
    var property = "";
    for (let i = 0; i < properties.length; i++) {
      if (properties[i].name == propertyName) {
        property = properties[i];
        break;
      }
    }
    var defaultValue = property.defaultValue;
    if (defaultValue) value = defaultValue;
    else {
      var valueType = property.valueType;
      if (valueType == "varchar" || valueType == "text") {
        value = "";
      } else if (valueType == "int" || valueType == "decimal") {
        value = "0";
      } else if (valueType == "datetime") {
        value = new Date().ToString("yyyy-MM-dd");
      }
    }
  } else {
    let properties = objectInfos[objectName].properties;
    for (let i = 0; i < properties.length; i++) {
      if (
        properties[i].name == propertyName &&
        properties[i].valueType == "decimal"
      ) {
        value = Math.round(value * 100) / 100;
        break;
      }
    }
  }
  return value;
}

//获取运算表达式的结果值
function getEvaluateExpressionResult(expression, options, foreachIndex) {
  var hasOperator = false; //是否含有运算符
  var exprStr = ""; //运算表达式字符串
  expression.forEach(function(expr) {
    if (expr.type == ExpressionTypeEnum.Variable) {
      exprStr += getObjectPropertyValue(
        expr.content.objectName,
        expr.content.propertyName,
        options,
        foreachIndex
      );
    } else if (expr.type == ExpressionTypeEnum.Constant) {
      exprStr += expr.content;
    } else if (expr.type == ExpressionTypeEnum.Operator) {
      exprStr += expr.content;
      hasOperator = true;
    } else if (expr.type == ExpressionTypeEnum.Func) {
      exprStr += getFuncResult(expr.content, options);
    }
  });
  if (hasOperator) {
    return eval(exprStr);
  } else return exprStr;
}

//获取函数运行结果
function getFuncResult(content, options) {
  switch (content.name) {
    case "计算时间差":
      return func_CalculationDate(content.inputVariables, options);
    case "计算平方":
      return func_CalculatingSquare(content.inputVariables, options);
    case "计算对数(e为底)":
      return func_CalculatingLog(content.inputVariables, options);
    case "计算e的n次幂":
      return func_CalculatingExp(content.inputVariables, options);
  }
}
//函数-e的N次幂
function func_CalculatingExp(inputVariables, options) {
  let square = getObjectPropertyValue(
    inputVariables[0].content.objectName,
    inputVariables[0].content.propertyName,
    options
  );
  return Math.exp(Number(square));
}
//函数-计算对数(e为底)
function func_CalculatingLog(inputVariables, options) {
  let data = getObjectPropertyValue(
    inputVariables[0].content.objectName,
    inputVariables[0].content.propertyName,
    options
  );
  let value = Math.log(Number(data));
  if (value == "-Infinity") value = 0;
  return value;
}
//函数-计算平方
function func_CalculatingSquare(inputVariables, options) {
  let data = getObjectPropertyValue(
    inputVariables[0].content.objectName,
    inputVariables[0].content.propertyName,
    options
  );
  let square = getObjectPropertyValue(
    inputVariables[1].content.objectName,
    inputVariables[1].content.propertyName,
    options
  );
  return Math.pow(Number(data), Number(square));
}
//函数-计算时间差
function func_CalculationDate(inputVariables, options) {
  let starDate = getObjectPropertyValue(
    inputVariables[0].content.objectName,
    inputVariables[0].content.propertyName,
    options
  );
  let endDate = getObjectPropertyValue(
    inputVariables[1].content.objectName,
    inputVariables[1].content.propertyName,
    options
  );
  let type = inputVariables[2].content;
  switch (type) {
    case "hour":
      var ms = new Date(endDate) - new Date(starDate);
      if (ms < 0) return 0;
      return Math.floor(ms / 1000 / 60 / 60);
  }
}

//输出结果
function outPutResult(options) {
  var result = {};
  var objectValues = options.objectValues;
  for (var key in objectValues) {
    var object = options.objectInfos[key];
    if (
      object.ioType == ObjectIoTypeEnum.Output ||
      object.ioType == ObjectIoTypeEnum.InputOrOutput
    )
      result[key] = objectValues[key];
  }
  return result;
}
//////////////////////////////////WebAPI start////////////////////////////////

//////////////////////////////////WebAPI End//////////////////////////////////

export { execute, builtObjectDict, outPutResult, evaluateBooleanExpression };
